import * as api from '../api/taxLimitation';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_TAX_LIMITATION_RUNS = createRequestTypes(
  `${prefix}/FETCH_TAX_LIMITATION_RUNS`,
);

export const fetchTaxLimitationRuns = makeApiActionCreatorV3(
  api.fetchTaxLimitationRuns,
  FETCH_TAX_LIMITATION_RUNS[START],
  FETCH_TAX_LIMITATION_RUNS[SUCCESS],
  FETCH_TAX_LIMITATION_RUNS[ERROR],
);

export const LAUNCH_TAX_LIMITATION_RUN = createRequestTypes(
  `${prefix}/LAUNCH_TAX_LIMITATION_RUN`,
);

export const launchTaxLimitationRun = makeApiActionCreatorV3(
  api.launchTaxLimitationRun,
  LAUNCH_TAX_LIMITATION_RUN[START],
  LAUNCH_TAX_LIMITATION_RUN[SUCCESS],
  LAUNCH_TAX_LIMITATION_RUN[ERROR],
);

export const FETCH_TAX_LIMITATION_RUN = createRequestTypes(
  `${prefix}/FETCH_TAX_LIMITATION_RUN`,
);

export const fetchTaxLimitationRun = makeApiActionCreatorV3(
  api.fetchTaxLimitationRun,
  FETCH_TAX_LIMITATION_RUN[START],
  FETCH_TAX_LIMITATION_RUN[SUCCESS],
  FETCH_TAX_LIMITATION_RUN[ERROR],
);

export const FETCH_ROLL_CORR_GROUPS_BY_YEAR = createRequestTypes(
  `${prefix}/FETCH_ROLL_CORR_GROUPS_BY_YEAR`,
);

export const fetchRollCorrOpenGroupsByYear = makeApiActionCreatorV3(
  api.fetchRollCorrOpenGroupsByYear,
  FETCH_ROLL_CORR_GROUPS_BY_YEAR[START],
  FETCH_ROLL_CORR_GROUPS_BY_YEAR[SUCCESS],
  FETCH_ROLL_CORR_GROUPS_BY_YEAR[ERROR],
);

export const FETCH_ROLL_CORR_REASONS = createRequestTypes(
  `${prefix}/FETCH_ROLL_CORR_REASONS`,
);

export const fetchRollCorrReasons = makeApiActionCreatorV3(
  api.fetchRollCorrReasons,
  FETCH_ROLL_CORR_REASONS[START],
  FETCH_ROLL_CORR_REASONS[SUCCESS],
  FETCH_ROLL_CORR_REASONS[ERROR],
);

export const FETCH_TAX_LIMITATIONS = createRequestTypes(
  `${prefix}/FETCH_TAX_LIMITATIONS`,
);

export const fetchTaxLimitations = makeApiActionCreatorV3(
  api.fetchTaxLimitations,
  FETCH_TAX_LIMITATIONS[START],
  FETCH_TAX_LIMITATIONS[SUCCESS],
  FETCH_TAX_LIMITATIONS[ERROR],
);

export const CREATE_TAX_LIMITATION = createRequestTypes(
  `${prefix}/CREATE_TAX_LIMITATION`,
);

export const createTaxLimitation = makeApiActionCreatorV3(
  api.createTaxLimitation,
  CREATE_TAX_LIMITATION[START],
  CREATE_TAX_LIMITATION[SUCCESS],
  CREATE_TAX_LIMITATION[ERROR],
);

export const FETCH_PROPOSED_TAX_LIMITATION = createRequestTypes(
  `${prefix}/FETCH_PROPOSED_TAX_LIMITATION`,
);

export const fetchProposedTaxLimitation = makeApiActionCreatorV3(
  api.fetchProposedTaxLimitation,
  FETCH_PROPOSED_TAX_LIMITATION[START],
  FETCH_PROPOSED_TAX_LIMITATION[SUCCESS],
  FETCH_PROPOSED_TAX_LIMITATION[ERROR],
);

export const APPLY_TAX_LIMITATION = createRequestTypes(
  `${prefix}/APPLY_TAX_LIMITATION`,
);

export const applyTaxLimitation = makeApiActionCreatorV3(
  api.applyTaxLimitation,
  APPLY_TAX_LIMITATION[START],
  APPLY_TAX_LIMITATION[SUCCESS],
  APPLY_TAX_LIMITATION[ERROR],
);

export const FETCH_TAX_LIMITATION_COMPRESS_RUNS = createRequestTypes(
  `${prefix}/FETCH_TAX_LIMITATION_COMPRESS_RUNS`,
);

export const fetchTaxlimitationCompressRuns = makeApiActionCreatorV3(
  api.fetchTaxlimitationCompressRuns,
  FETCH_TAX_LIMITATION_COMPRESS_RUNS[START],
  FETCH_TAX_LIMITATION_COMPRESS_RUNS[SUCCESS],
  FETCH_TAX_LIMITATION_COMPRESS_RUNS[ERROR],
);

export const CREATE_TAX_LIMITATION_COMPRESS_RUNS = createRequestTypes(
  `${prefix}/CREATE_TAX_LIMITATION_COMPRESS_RUNS`,
);

export const createTaxLimitationCompressRuns = makeApiActionCreatorV3(
  api.createTaxLimitationCompressRuns,
  CREATE_TAX_LIMITATION_COMPRESS_RUNS[START],
  CREATE_TAX_LIMITATION_COMPRESS_RUNS[SUCCESS],
  CREATE_TAX_LIMITATION_COMPRESS_RUNS[ERROR],
);

export const FETCH_COMPRESS_RUN_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_COMPRESS_RUN_PROPERTIES`,
);

export const fetchCompressRunProperties = makeApiActionCreatorV3(
  api.fetchCompressRunProperties,
  FETCH_COMPRESS_RUN_PROPERTIES[START],
  FETCH_COMPRESS_RUN_PROPERTIES[SUCCESS],
  FETCH_COMPRESS_RUN_PROPERTIES[ERROR],
);

export const UPDATE_TAX_LIMITATION_COMPRESS_RUNS = createRequestTypes(
  `${prefix}/UPDATE_TAX_LIMITATION_COMPRESS_RUNS`,
);

export const updateTaxLimitationCompressRuns = makeApiActionCreatorV3(
  api.updateTaxLimitationCompressRuns,
  UPDATE_TAX_LIMITATION_COMPRESS_RUNS[START],
  UPDATE_TAX_LIMITATION_COMPRESS_RUNS[SUCCESS],
  UPDATE_TAX_LIMITATION_COMPRESS_RUNS[ERROR],
);

export const FETCH_PROPERTY_YEAR_EDITABLE = createRequestTypes(
  `${prefix}/FETCH_PROPERTY_YEAR_EDITABLE`,
);

export const fetchPropertyYearEditable = makeApiActionCreatorV3(
  api.fetchPropertyYearEditable,
  FETCH_PROPERTY_YEAR_EDITABLE[START],
  FETCH_PROPERTY_YEAR_EDITABLE[SUCCESS],
  FETCH_PROPERTY_YEAR_EDITABLE[ERROR],
);

export const FETCH_TAX_LIMITATION_HITL_RUNS = createRequestTypes(
  `${prefix}/FETCH_TAX_LIMITATION_HITL_RUNS`,
);

export const fetchTaxlimitationHITLRuns = makeApiActionCreatorV3(
  api.fetchTaxlimitationHITLRuns,
  FETCH_TAX_LIMITATION_HITL_RUNS[START],
  FETCH_TAX_LIMITATION_HITL_RUNS[SUCCESS],
  FETCH_TAX_LIMITATION_HITL_RUNS[ERROR],
);

export const CREATE_TAX_LIMITATION_HITL_RUN = createRequestTypes(
  `${prefix}/CREATE_TAX_LIMITATION_HITL_RUN`,
);

export const createTaxLimitationHITLRun = makeApiActionCreatorV3(
  api.createTaxLimitationHITLRun,
  CREATE_TAX_LIMITATION_HITL_RUN[START],
  CREATE_TAX_LIMITATION_HITL_RUN[SUCCESS],
  CREATE_TAX_LIMITATION_HITL_RUN[ERROR],
);

export const FETCH_TAX_LIMITATION_HITL_RUN_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_TAX_LIMITATION_HITL_RUN_PROPERTIES`,
);

export const fetchTaxlimitationHITLRunProperties = makeApiActionCreatorV3(
  api.fetchTaxlimitationHITLRunProperties,
  FETCH_TAX_LIMITATION_HITL_RUN_PROPERTIES[START],
  FETCH_TAX_LIMITATION_HITL_RUN_PROPERTIES[SUCCESS],
  FETCH_TAX_LIMITATION_HITL_RUN_PROPERTIES[ERROR],
);

export const UPDATE_TAX_LIMITATION_HITL_RUN = createRequestTypes(
  `${prefix}/UPDATE_TAX_LIMITATION_HITL_RUN`,
);

export const updateTaxLimitationHITLRun = makeApiActionCreatorV3(
  api.updateTaxLimitationHITLRun,
  UPDATE_TAX_LIMITATION_HITL_RUN[START],
  UPDATE_TAX_LIMITATION_HITL_RUN[SUCCESS],
  UPDATE_TAX_LIMITATION_HITL_RUN[ERROR],
);

export const FETCH_TAX_LIMITATION_EXEMPTION_BETA_CALCULATION =
  createRequestTypes(
    `${prefix}/FETCH_TAX_LIMITATION_EXEMPTION_BETA_CALCULATION`,
  );

export const fetchTaxlimitationExemptionBetaCalculation =
  makeApiActionCreatorV3(
    api.fetchTaxlimitationExemptionBetaCalculation,
    FETCH_TAX_LIMITATION_EXEMPTION_BETA_CALCULATION[START],
    FETCH_TAX_LIMITATION_EXEMPTION_BETA_CALCULATION[SUCCESS],
    FETCH_TAX_LIMITATION_EXEMPTION_BETA_CALCULATION[ERROR],
  );

export const FETCH_SCHOOL_DISTRICT_MCR_VALIDATION = createRequestTypes(
  `${prefix}/FETCH_SCHOOL_DISTRICT_MCR_VALIDATION`,
);

export const fetchSchoolDistrictMCRValidation = makeApiActionCreatorV3(
  api.fetchSchoolDistrictMCRValidation,
  FETCH_SCHOOL_DISTRICT_MCR_VALIDATION[START],
  FETCH_SCHOOL_DISTRICT_MCR_VALIDATION[SUCCESS],
  FETCH_SCHOOL_DISTRICT_MCR_VALIDATION[ERROR],
);
